/* global axios */
import ApiClient from './ApiClient';

class CommissionAgreementsAPI extends ApiClient {
  constructor() {
    super('commission_agreements', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(agreement) {
    return axios.post(this.url, { commission_agreement: agreement });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }
}

export default new CommissionAgreementsAPI();
